import {
  Body,
} from 'src/containers';

export const MainRouter = (props) => {
	return (
		<Body />
	)
};
